import {Component, Input} from '@angular/core'
import {IconDefinition} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'

@Component({
  selector: 'bgo-why-buildigo-item',
  templateUrl: './why-buildigo-item.component.html',
  imports: [FontAwesomeModule],
})
export class WhyBuildigoItemComponent {
  @Input() title!: string
  @Input() description!: string
  @Input() icon?: IconDefinition
}
